import styled from 'styled-components';
import * as DesignSystem from '../../../assets/styles/StyleTypes';

export const GraphicBarContainer = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  border-radius: ${DesignSystem.BorderRadius.XS};
  grid-area: graphic;

  @media screen and (max-width: 960px) {
    width: auto;
    flex-direction: row;
    gap: 20px;
  }
  @media screen and (max-width: 480px) {
    flex-direction: column;
  }
`;

export const BoxList = styled.div`

  .list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 5px;

    li {
      font-size: 13px;
      display: flex;
      width: 100%;
      gap: 5px;

      p {
        padding: 5px 0;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin: 0;
        font-weight: 500;

        span {
          background: ${DesignSystem.Colors.INFO_GRADIENT};
          padding: 4px 8px;
          border-radius: ${DesignSystem.BorderRadius.SM};
          font-family: Roboto, sans-serif;
          margin-right: 5px;
        }
      }
    }
  }
`;

export const GraphicBox = styled.section`
  width: 100%;
  max-width: 100%;
  margin-top: 1rem;
  overflow: hidden;

  .graphic-content {
    width: 100%;
    max-width: 100%;
    overflow: auto;
    padding-bottom: 0.5rem;
  }

  &[data-scroll='horizontal'] .graphic-content {
    overflow-x: auto;
    overflow-y: hidden;
    cursor: grab;
  }

  &[data-scroll='vertical'] .graphic-content {
    overflow-y: auto;
    overflow-x: hidden;
  }

  .bar {
    height: 350px;
  }

  canvas {
    background: transparent;
    max-width: 100% !important;
  }

  .chartjs-render-monitor {
    font-family: 'Roboto', sans-serif;
  }

  .chartjs-x-axis-label,
  .chartjs-y-axis-label {
    white-space: normal !important;
    text-align: center !important;
    word-break: break-word !important;
  }

  @media screen and (max-width: 768px) {
    .bar {
      min-height: 500px; 
    }
  }
`;

export const LegendList = styled.ul`
  margin: 0;
  padding: 12px 0 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
`;

export const LegendItem = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: ${DesignSystem.BorderRadius.SM};
  font-size: 13px;
  font-weight: 600;
`;

export const LegendColor = styled.span`
  width: 14px;
  height: 14px;
  border-radius: ${DesignSystem.BorderRadius.XS};
  display: inline-block;
  border: 1px solid ${DesignSystem.Colors.HIGH_MEDIUM};
`;

